import axiosInstance from "api/axios";
import { Notification } from "types/notification.type";

export const notificationService = {
  getAll: async (
    companyId: number,
    page: number = 1,
    limit: number = 10,
    filters: Record<string, any> = {}
  ): Promise<{ data: Notification[]; total: number }> => {
    const params = { page, limit, ...filters };
    const { data } = await axiosInstance.get(`/notifications/company/${companyId}`, { params });
    return data;
  },

  getById: async (id: number): Promise<Notification> => {
    const { data } = await axiosInstance.get(`/notifications/${id}`);
    return data.data;
  },

  markAsRead: async (id: number) => {
    const { data } = await axiosInstance.put(`/notifications/${id}/read`);
    return data.data;
  },

  markAllAsRead: async (companyId: number, options?: { userId?: number; role?: string }) => {
    const { data } = await axiosInstance.put(`/notifications/company/${companyId}/read-all`, {
      params: options,
    });
    return data;
  },

  delete: async (id: number) => {
    const { data } = await axiosInstance.delete(`/notifications/${id}`);
    return data;
  },
};
